// extracted by mini-css-extract-plugin
export default {"button":"InfoIconButton_button__VUUgg"};